import React from 'react';

/**
 * Скелетон главной страницы с теми же отступами и размерами блоков, что и реальная HomePage.
 * Используется как Suspense fallback для маршрута "/" — уменьшает CLS при подгрузке LazyHomePage.
 */
const HomePageSkeleton = () => (
  <>
    {/* Hero — те же классы секции и контейнера */}
    <section
      className="relative bg-gradient-to-br from-gray-500 via-gray-600 to-gray-800 text-white overflow-hidden"
      aria-hidden="true"
    >
      <div
        className="absolute inset-0 opacity-20 z-0"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}
      />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-[2.43rem] pb-[2.7rem]">
        <div className="text-center">
          {/* Заголовок — высота как у h1 text-3xl md:text-5xl */}
          <div className="h-9 md:h-12 w-3/4 max-w-2xl mx-auto mb-4 bg-white/25 rounded-lg animate-pulse" />
          {/* Подзаголовок — 2 строки */}
          <div className="max-w-4xl mx-auto space-y-2 mb-12">
            <div className="h-6 md:h-7 w-full bg-white/15 rounded animate-pulse" />
            <div className="h-6 md:h-7 w-4/5 mx-auto bg-white/15 rounded animate-pulse" />
          </div>
          {/* Кнопка */}
          <div className="flex justify-center mb-[3.24rem]">
            <div className="h-12 w-48 bg-white/25 rounded-xl animate-pulse" />
          </div>
          {/* Блок слайдшоу — aspect-video как в реальной странице (важно для LCP) */}
          <div className="max-w-[58.52rem] mx-auto">
            <div className="h-7 w-48 mx-auto mb-4 bg-white/15 rounded animate-pulse" />
            <div className="relative aspect-video bg-white/10 backdrop-blur-sm rounded-2xl border border-white/20 overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-br from-gray-400/30 to-gray-600/30 animate-pulse rounded-2xl" />
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* Stats — py-16, сетка 2x2 / 4 колонки */}
    <section className="py-16 bg-white border-b">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="text-center">
              <div className="h-9 md:h-10 w-16 mx-auto mb-2 bg-gray-200 rounded animate-pulse" />
              <div className="h-4 w-20 mx-auto bg-gray-100 rounded animate-pulse" />
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* Features — заголовок + карточки, чтобы не прыгало при появлении контента */}
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <div className="h-10 md:h-12 w-2/3 max-w-xl mx-auto mb-6 bg-gray-200 rounded-lg animate-pulse" />
          <div className="h-6 w-full max-w-2xl mx-auto bg-gray-100 rounded animate-pulse" />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {[1, 2, 3].map((i) => (
            <div key={i} className="bg-white rounded-2xl shadow-lg p-8">
              <div className="h-14 w-14 rounded-xl bg-gray-200 mb-6 animate-pulse" />
              <div className="h-6 w-3/4 mb-4 bg-gray-200 rounded animate-pulse" />
              <div className="space-y-2">
                <div className="h-4 w-full bg-gray-100 rounded animate-pulse" />
                <div className="h-4 w-5/6 bg-gray-100 rounded animate-pulse" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  </>
);

export default HomePageSkeleton;
